import WaveSurfer from 'wavesurfer.js/dist/wavesurfer';
// console.log('WaveSurfer: ', WaveSurfer);
import MinimapPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.minimap';
import {
  AUDIO_DOWNLOAD_TYPE
} from '../../core/local-storage.service';

const AUDIO_TYPES = ['mp3', 'ogg', 'wav', 'wma'];
const AUDIO_CONTENT_TYPES = {
  'mp3': 'audio/mpeg',
  'ogg': 'audio/ogg',
  'wav': 'audio/wav',
  'wma': 'audio/wma',
};

export function WavesurferComponent() {
  return {
    restrict: 'E',
    scope: {
      fact: '=',
      src: '@',
      loading: '=',
    },
    controller: function($scope, $element, $timeout, AudioWavesService) {
      if (!$scope.fact) return;
      $element.css('display', 'block');

      // barHeight: 1,
      if ($scope.fact.wavesurfer) {
        const pluginName = 'minimap';
        const plugin = MinimapPlugin.create({
          container: $element[0],
          waveColor: '#004f75',
          progressColor: 'rgb(0, 79, 117, 0.2)',
          barHeight: 2,
          height: 50,
          cursorWidth: 3,
          cursorColor: 'red',
        });

        if ($scope.fact.wavesurfer[pluginName]) $scope.fact.wavesurfer.destroyPlugin(pluginName);
        $scope.fact.wavesurfer.addPlugin(plugin).initPlugin(pluginName);
        $scope.$emit('wavesurferReady', $scope.fact);
      } else {
        const options = {
          container: $element[0],
          waveColor: '#004f75',
          progressColor: 'rgb(0, 79, 117, 0.2)',
          barHeight: 2,
          height: 50,
          cursorWidth: 3,
          cursorColor: 'red',
        };
        $scope.fact.wavesurfer = WaveSurfer.create(options);
        if ($scope.src) {
          $scope.fact.wavesurfer.load($scope.src);
          $scope.loading = true;
          $scope.fact.wavesurfer.on('ready', () => {
            $scope.loading = false;
            if (!$scope.fact.wavesurfer) return;
            $scope.fact.wavesurfer.hasLoaded = true;
            $scope.$emit('wavesurferReady', $scope.fact, true);
          });
        }
      }
      $scope.$emit('wavesurferInit', $scope.fact);
    }
  };
}



// WEBPACK FOOTER //
// ./src/facts/audio-waves/wavesurfer.component.js